<template>
  <section>
    <b-row>
      <b-col xl="3" lg="3" sm="6" cols="12" class="d-flex">
        <vertical-card
          :statistic="manager.active_competitions_count || '0'"
          statistic-title="Active competitions"
          class="w-100"
          :loading="loading"
        />
      </b-col>
      <b-col xl="3" lg="3" sm="6" cols="12" class="d-flex">
        <vertical-card
          :statistic="manager.upcoming_competitions_count || '0'"
          statistic-title="Upcomming competitions"
          class="w-100"
          :loading="loading"
        />
      </b-col>
      <b-col xl="3" lg="3" sm="6" cols="12" class="d-flex">
        <vertical-card
          :statistic="manager.expire_competitions_count || '0'"
          statistic-title="Expired competitions"
          class="w-100"
          :loading="loading"
        />
      </b-col>
      <b-col xl="3" lg="3" sm="6" cols="12" class="d-flex">
        <vertical-card
          :statistic="manager.total_competitions_count || '0'"
          statistic-title="Total competitions"
          class="w-100"
          :loading="loading"
        />
      </b-col>
    </b-row>

    <div>
      <div
        class="d-flex flex-wrap align-items-center w-100 pt-lg-3 pb-lg-4 pb-1"
      >
        <b-form
          @submit.prevent="filter"
          :class="[
            'filters rounded p-1 my-1 d-flex align-items-center flex-wrap ',
            userData.type != 'user' ? 'col-xl-9 col-lg-8' : 'col-12',
          ]"
        >
          <div class="col-sm-4 col-12 p-50 d-flex align-items-center">
            <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
            <v-select
              :options="types"
              v-model="type"
              label="label"
              :reduce="(option) => option.value"
              :searchable="false"
              placeholder="Display on the page"
              class="w-100"
            ></v-select>
          </div>

          <div class="col-sm-5 col-12 d-flex align-items-center p-50">
            <template v-if="type == 'partner_id'">
              <div class="w-100 py-50 px-sm-50 px-0">
                <select-box
                  v-model="partnerId"
                  label="text"
                  class="w-100"
                  select="id"
                  searchable
                  url="partner"
                />
              </div>
            </template>
            <b-form-input
              v-else
              placeholder="search"
              v-model.trim="search"
              :disabled="!type"
            />
          </div>
          <div class="col-sm-3 col-12 p-50">
            <b-button
              class="w-100"
              type="submit"
              :disabled="!search && !(!search && partnerId)"
            >
              <span class="text-muted h5"> Filtering</span>
            </b-button>
          </div>
        </b-form>
        <div
          class="d-flex col-xl-3 col-lg-4 px-md-1"
          v-if="userData.type != 'user'"
        >
          <div class="rounded filters p-2 my-1 w-100">
            <b-button
              :disabled="
                userData.type == 'partner'
                  ? !userData.can_create_competition
                  : false
              "
              :class="[
                'w-100 ',
                userData.type == 'partner'
                  ? userData.can_create_competition
                    ? 'gradient-btn py-1'
                    : 'bg-secondary px-50'
                  : 'gradient-btn py-1',
              ]"
              :to="{ name: 'create-competition' }"
            >
              <feather-icon
                icon="PlusIcon"
                v-if="
                  userData.type == 'partner'
                    ? userData.can_create_competition
                    : true
                "
              />
              <span>{{
                userData.type == "partner"
                  ? userData.can_create_competition
                    ? "Create competition"
                    : "Upgrade your plan to create more competition"
                  : "Create competition"
              }}</span>
            </b-button>
          </div>
        </div>
      </div>
      <b-row>
        <template v-if="loading">
          <b-col lg="4" md="6" cols="12" v-for="index in 3" :key="index">
            <b-card no-body class="p-2 w-100">
              <b-skeleton width="100%" height="180px" />
              <b-skeleton width="40%" height="30px" class="mx-1" />
              <b-skeleton width="100%" height="80px" class="my-1" />
              <b-skeleton width="100%" height="40px" class="my-1" />
              <b-skeleton width="100%" height="30px" class="mt-1 mb-0" />
            </b-card>
          </b-col>
        </template>
        <template v-else-if="competitions.length">
          <b-col
            lg="4"
            md="6"
            cols="12"
            v-for="(competition, index) in competitions"
            :key="index"
            class="d-flex mb-sm-0 mb-2"
          >
            <competition-card
              :competition="competition"
              @showPayModal="showPayModalEmit"
              @showChangeStatusModal="
                changeStatusItem = $event;
                showChangeStatusModal = true;
              "
              @cancel="cancel"
            />
          </b-col>
        </template>
        <template v-else>
          <div class="w-100 px-1">
            <b-alert
              show
              variant="secondary"
              class="w-100 d-flex justify-content-center p-5 h3 my-2"
            >
              no information
            </b-alert>
          </div>
        </template>
      </b-row>

      <div class="w-100 d-flex flex-wrap align-items-center py-2">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
    </div>
    <pay-modal
      payType="readyToPay"
      :item="payItem"
      :visible="showPayModal"
      v-model="showPayModal"
    />
    <change-status-modal
      :item="changeStatusItem"
      :visible="showChangeStatusModal"
      v-model="showChangeStatusModal"
      @updateCompetitions="getCompetitions"
    />
    <!-- TradingView Widget BEGIN -->
    <!-- <div class="tradingview-widget-container">
      <div id="tradingview_be837"></div>
    </div> -->
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BPagination,
  BSkeleton,
  BAlert,
  BForm,
  BFormInput,
  BCard,
} from "bootstrap-vue";
import VerticalCard from "./VerticalCard.vue";
import CompetitionCard from "./CompetitionCard.vue";
import ChangeStatusModal from "./ChangeStatusModal.vue";
import PayModal from "./PayModal.vue";
import VSelect from "vue-select";
import qs from "qs";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  // created() {
  // let externalScript = document.createElement("script");
  // externalScript.setAttribute("src", "https://s3.tradingview.com/tv.js");
  // externalScript.setAttribute("type", "text/javascript");
  // document.head.appendChild(externalScript);

  // let externalScript2 = document.createElement("script");
  // externalScript2.setAttribute(
  //   "src",
  //   "https://s3.tradingview.com/external-embedding/embed-widget-symbol-info.js"
  // );
  // externalScript2.setAttribute("type", "text/javascript");
  // document.head.appendChild(externalScript2);

  // https://www.tradingview.com/widget/symbol-info/

  // https://www.tradingview.com/widget/symbol-overview/

  // setTimeout(() => {
  //   this.symbols = new TradingView.MediumWidget({
  //     symbols: [
  //       ["Apple", "AAPL|1D"],
  //       ["Google", "GOOGL|1D"],
  //       ["Microsoft", "MSFT|1D"],
  //       ["NASDAQ:TSLA|12M"],
  //       ["FX:EURUSD|ALL"],
  //     ],
  //     chartOnly: false,
  //     width: 500,
  //     height: 500,
  //     locale: "en",
  //     colorTheme: "light",
  //     autosize: false,
  //     showVolume: false,
  //     hideDateRanges: false,
  //     scalePosition: "right",
  //     scaleMode: "Normal",
  //     fontFamily:
  //       "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
  //     fontSize: "10",
  //     noTimeScale: false,
  //     valuesTracking: "1",
  //     chartType: "line",
  //     container_id: "tradingview_be837",
  //   });
  // }, 1000);
  // },
  components: {
    BRow,
    BCol,
    VerticalCard,
    BButton,
    BPagination,
    BSkeleton,
    BAlert,
    BForm,
    BFormInput,
    BCard,
    CompetitionCard,
    ChangeStatusModal,
    PayModal,
    VSelect,
    SelectBox,
  },
  data() {
    return {
      symbols: {},
      partnerId: "",
      payItem: {},
      showPayModal: false,
      changeStatusItem: {},
      showChangeStatusModal: false,
      meetup: {
        mediaData: [
          {
            avatar: "CalendarIcon",
            title: "Sat, May 25, 2020",
            subtitle: "10:AM to 6:PM",
          },
          {
            avatar: "MapPinIcon",
            title: "Central Park",
            subtitle: "Manhattan, New york City",
          },
        ],
        avatars: [
          {
            avatar: require("@/assets/images/portrait/small/avatar-s-9.jpg"),
            fullName: "Billy Hopkins",
          },
          {
            avatar: require("@/assets/images/portrait/small/avatar-s-6.jpg"),
            fullName: "Amy Carson",
          },
          {
            avatar: require("@/assets/images/portrait/small/avatar-s-8.jpg"),
            fullName: "Brandon Miles",
          },
          {
            avatar: require("@/assets/images/portrait/small/avatar-s-7.jpg"),
            fullName: "Daisy Weber",
          },
          {
            avatar: require("@/assets/images/portrait/small/avatar-s-20.jpg"),
            fullName: "Jenny Looper",
          },
        ],
      },
      types: [
        { label: "Name", value: "name" },
        { label: "Symbol", value: "symbol" },
        { label: "Partner Id", value: "partner_id" },
        // { label: "Broker", value: "broker" },
        // { label: "Award", value: "award" },
        { label: "Award type", value: "award_type" },
        // { label: "Draw down value", value: "draw_down_value" },
        { label: "Max participant value", value: "max_participant_value" },
        { label: "Minimum trade value", value: "minimum_trade_value" },
        { label: "Profit value", value: "profit_value" },
        { label: "Starting balance value", value: "starting_balance_value" },
      ],
      type: "",
      search: "",
      rows: 100,
      url: "/panel/competitions",
      currentPage: 1,
      loading: false,
      pagination: {},
      competitions: [],
      manager: {},
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (this.$route.fullPath != "/competitions") {
        this.$router.push({
          name: "competitions",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "competitions",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      async handler(val) {
        this.loading = true;
        await this.getProfile();
        await this.getManager();
        await this.getCompetitions();
        this.loading = false;
      },
      immediate: true,
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "competitions",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "competitions",
        query: {},
      });
    }
  },
  methods: {
    cancel(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about canceling this competition ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.post(`/panel/competitions/${id}/cancel`);
              await this.getCompetitions();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your competition has been canceled successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    async getProfile() {
      try {
        if (this.userData.type == "partner") {
          const { data } = await this.$http.get(`/panel/profile/partner`);
          await localStorage.setItem(
            "userData",
            JSON.stringify({
              ...data.partner.data,
              documents: data.documents.data,
              type: "partner",
            })
          );
          await this.$store.dispatch("auth/setUserData", {
            ...data.partner.data,
            documents: data.documents.data,
            type: "partner",
          });
        } else {
          const { data } = await this.$http.get(`/panel/profile/user`);

          await localStorage.setItem(
            "userData",
            JSON.stringify({
              ...data.user,
              email_verified: data.user.email_verified_at ? true : false,
              type: data.abilities[0].includes("admin") ? "admin" : "user",
            })
          );
          await this.$store.dispatch("auth/setUserData", {
            ...data.user,
            email_verified: data.user.email_verified_at ? true : false,
            type: data.abilities[0].includes("admin") ? "admin" : "user",
          });
        }
      } catch (error) {}
    },
    showPayModalEmit(item) {
      this.payItem = item;
      this.showPayModal = true;
    },
    filter() {
      if (this.type) {
        let filter = {};
        if (this.type == "partner_id") {
          filter[this.type] = this.partnerId;
        } else {
          filter[this.type] = this.search;
        }
        this.$router.push({
          name: "competitions",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/competitions") {
        this.$router.push({
          name: "competitions",
        });
      }
    },
    async getManager() {
      try {
        const { data } = await this.$http.get("/panel/competitions-manager");
        this.manager = data;
      } catch (err) {}
    },
    async getCompetitions() {
      try {
        const params = {
          per_page: 6,
          ...this.$route.query,
          include: ["brokers", "partner"],
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.competitions = await data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
    },
  },
};
</script>
